import BaseBlock from "./BaseBlock";
import Swiper, {Autoplay, Navigation, Pagination, Thumbs} from "swiper";

export default class Slider extends BaseBlock {
	breakpointsBase = "container";
	/**
	 * @type {HTMLElement|null}
	 */
	mainWrapper = null;
	/**
	 * @type {HTMLElement|null}
	 */
	thumbsWrapper = null;

	init() {

		/**
		 * Main Slider
		 * @type {HTMLElement}
		 */
		const mainSliderEl = this.block.querySelector(".swiper-main");
		const thumbsSliderEl = this.block.querySelector(".swiper-thumbs");


		if (mainSliderEl) {
			const customOptions = JSON.parse(mainSliderEl.dataset.options);
			this.mainWrapper = this.block.querySelector(".slider-main");
			let options = {
				loop: true,
				modules: [Navigation, Pagination],
				navigation: {
					prevEl: this.mainWrapper.querySelector(".slider-btn-prev"),
					nextEl: this.mainWrapper.querySelector(".slider-btn-next"),
				},
				pagination: {
					el: this.mainWrapper.querySelector(".slider-pagination"),
					clickable: true
				},
				breakpointsBase: this.breakpointsBase,
				on: {
					init: () => {
						this.setNavigationVisibility();
					},
					resize: () => {
						this.setNavigationVisibility();
					}
				},
				...customOptions
			}

			if (options.autoplay) {
				options.modules = [Autoplay, Navigation, Pagination];
			}

			if (thumbsSliderEl) {
				this.thumbsWrapper = this.block.querySelector(".slider-thumbs");
				let thumbsSwiper = new Swiper(thumbsSliderEl, {
					slidesPerView: 4,
					spaceBetween: 10,
					watchSlidesProgress: true,
					breakpoints: {
						728: {
							slidesPerView: 6
						},
						1240: {
							slidesPerView: 7
						},
						1540: {
							slidesPerView: 8
						},
					},
					navigation: {
						prevEl: this.thumbsWrapper.querySelector(".slider-btn-prev"),
						nextEl: this.thumbsWrapper.querySelector(".slider-btn-next")
					},
					modules: [Navigation]
				});

				if (thumbsSwiper) {
					options.modules.push(Thumbs);
					options.thumbs = {
						swiper: thumbsSwiper
					}
				}
			}

			new Swiper(mainSliderEl, options);
		}
	}

	setNavigationVisibility() {
		if (window.innerWidth - this.block.querySelector('.slider').offsetWidth > 168) {
			this.mainWrapper.querySelector(".slider-btn-prev").style.display = 'block';
			this.mainWrapper.querySelector(".slider-btn-next").style.display = 'block';
		} else {
			this.mainWrapper.querySelector(".slider-btn-prev").style.display = 'none';
			this.mainWrapper.querySelector(".slider-btn-next").style.display = 'none';
		}
	}
}
